/**
 * Picker de carrousel produits pour le Content Builder (mode édition CMS).
 *
 * Déporté depuis menu_right.blade.php (on évite le JS dans les vues). Ne s'active
 * que si la modale #carouselPickerModal est présente (donc en contexte CMS édition).
 * Expose window.openCarouselPickerModal(), appelé par le bouton "Carrousel produit"
 * du quickadd ContentBuilder (cf. bundle contentbuilder.js, handler .add-carousel).
 *
 * Les URLs (liste des sélections / preview) sont fournies par data-attributes sur
 * la modale, car un composant compilé ne peut pas appeler le helper route() de Blade.
 */
export default function initCarouselPicker() {
    const modalEl = document.getElementById('carouselPickerModal');
    if (!modalEl) {
        return;
    }

    const $ = window.jQuery;
    const listUrl = modalEl.getAttribute('data-list-url');
    const previewUrlTemplate = modalEl.getAttribute('data-preview-url');
    const modal = new window.bootstrap.Modal(modalEl);

    function openModal() {
        const $select = $('#carouselSelectionPicker');

        $select.html('<option value="">Chargement...</option>');
        $('#carouselPickerInsert').prop('disabled', true);
        modal.show();

        $.get(listUrl)
            .done((data) => {
                if (!data.length) {
                    $select.html('<option value="">Aucune sélection disponible</option>');
                    return;
                }
                const options = data.map((s) => {
                    const safeName = $('<div>').text(s.name).html();
                    return '<option value="' + s.id + '" data-name="' + safeName + '">' + safeName + '</option>';
                });
                $select.html('<option value="">-- Choisir une sélection --</option>' + options.join(''));
            })
            .fail(() => {
                $select.html('<option value="">Erreur de chargement</option>');
            });

        $select.off('change.carousel').on('change.carousel', function () {
            $('#carouselPickerInsert').prop('disabled', !$(this).val());
        });
    }

    function insertCarousel(safeId, safeName, inner, isPlaceholder) {
        const style = isPlaceholder
            ? ' style="border:2px dashed #6c757d;padding:20px;text-align:center;border-radius:4px;background:#f8f9fa;"'
            : '';
        const carouselHtml = '<div class="product-carousel-cms"'
            + ' data-selection-id="' + safeId + '"'
            + ' data-selection-name="' + safeName + '"'
            + style + '>'
            + inner
            + '</div>';

        // data-noedit sur la colonne : supprime la toolbar d'édition de lien dans
        // ContentBuilder (cf. patch Hyperlink.click dans le bundle contentbuilder.js).
        // Le contenu du carrousel est régénéré à chaque affichage par
        // CmsController::processCarousels() ; l'éditer n'aurait aucun effet.
        const rowHtml = '<div class="row clearfix"><div class="column full" data-noedit>'
            + carouselHtml
            + '</div></div>';

        if (window.HegydContentBuilder && window.HegydContentBuilder.builder) {
            // Restaure la colonne active capturée à l'ouverture de la modale (cf.
            // handler .add-carousel dans contentbuilder.js) pour insérer à la
            // position du "+". On vérifie qu'elle est toujours dans le DOM.
            if (window.__carouselInsertCol && document.body.contains(window.__carouselInsertCol)) {
                window.HegydContentBuilder.builder.activeCol = window.__carouselInsertCol;
            }
            window.HegydContentBuilder.builder.addSnippet(rowHtml);
        }
    }

    function onInsert() {
        const $option = $('#carouselSelectionPicker').find(':selected');
        const id = $option.val();
        const name = $option.data('name') || $option.text();

        if (!id) {
            return;
        }

        const safeId = parseInt(id, 10);
        const safeName = $('<div>').text(name).html();

        modal.hide();

        // Contenu de repli (sélection vide ou erreur réseau) : un placeholder qui
        // conserve quand même le marqueur, régénéré ensuite par processCarousels().
        const placeholderInner = '<p style="margin:0;color:#495057;"><strong>&#128230; Carrousel produits</strong></p>'
            + '<p style="margin:4px 0 0;color:#6c757d;">' + safeName + '</p>';

        // On récupère le carrousel rendu AVANT de l'insérer, puis on insère le bloc
        // déjà rempli. Plus de placeholder à re-cibler après coup (un sélecteur
        // global ciblerait le mauvais bloc si plusieurs partagent la même sélection).
        const previewUrl = previewUrlTemplate.replace('__ID__', safeId);
        $.get(previewUrl)
            .done((html) => {
                const hasHtml = html && html.trim().length;
                insertCarousel(safeId, safeName, hasHtml ? html : placeholderInner, ! hasHtml);
            })
            .fail(() => {
                insertCarousel(safeId, safeName, placeholderInner, true);
            });
    }

    $('#carouselPickerInsert').on('click', onInsert);
    window.openCarouselPickerModal = openModal;
}
